import { gql } from '@apollo/client';
/**
 * @const LogOpeningDealMutation
 * @since 1.0.0
 */
export const LogOpeningDealMutation = gql `
  mutation LogOpeningDealMutation($input: LogOpeningDealInput!) {
    logOpeningDeal(input: $input)
  }
`;
